import React from "react";
import { BirthDayDetails } from "../../../models/BirthDaysModels/BirthDayDetails";
import { Grid } from "@material-ui/core";
import InputText from "../../../../features/InputText";
import TextAreaCustom from "../../../../features/TextAreaCustom";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import "./style.scss";

interface IProps {
  birthDayDetails: BirthDayDetails;
  onSetBirthDayDetails: (value: BirthDayDetails) => void;
  onNext: () => void;
}

const ThirdStep: React.FC<IProps> = ({ birthDayDetails, onSetBirthDayDetails, onNext }: IProps) => {
  const { t } = useTranslation();
  const validateForm = (): boolean => {
    return (
      Boolean(birthDayDetails.customerName) &&
      Boolean(birthDayDetails.customerLastName) &&
      Boolean(birthDayDetails.email) &&
      Boolean(birthDayDetails.phone)
    );
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <b>{t("osoba_rezerwujaca")}</b>
      </Grid>


      <div className="birthday-input-container flex-between-center flex-wrap">
          <div className="input-holder">
          <InputText
          value={birthDayDetails.customerName}
          label={t("imie")}
          name={"fname"}
          type="text"
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, customerName: value })}
        />
          </div>

          <div className="input-holder">  <InputText
                type="text"
          value={birthDayDetails.customerLastName}
          label={t("nazwisko")}
          name={"flastname"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, customerLastName: value })}
        /></div>

          <div className="input-holder">  <InputText
          value={birthDayDetails.email}
          label={"Email"}
          type="email"
          name={"femail"}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, email: value })}
        /></div>

          <div className="input-holder">   <InputText
          value={birthDayDetails.phone}
          label={t("telefon")}
          name={"fphone"}
          type="number"
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, phone: value })}
        /></div>

      </div>


      <div className="birthday-input-container">
      <TextAreaCustom
          label={t("dodatkowe_informacje_nt_rezerwacji")}
          value={birthDayDetails.additionalInfo}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, additionalInfo: value })}
          name={"fadditionalInfo"}
        />
        <div className="alert-yellow alert">
        {t("w_tym_oknie_wpisz_przedzial_wiekowy_swojej_grupy")}
        </div>
        
      </div>





{/*       
      <Grid item xs={8}>
        <CheckboxCustom
          label={t("chce_fakture")}
          value={birthDayDetails.isInvoice}
          setValue={(value: boolean) => onSetBirthDayDetails({ ...birthDayDetails, isInvoice: value })}
        />
      </Grid>
      <Grid item xs={12}>
        <TextAreaCustom
          label={t("dodatkowe_informacje_nt_rezerwacji")}
          value={birthDayDetails.additionalInfo}
          setValue={(value: string) => onSetBirthDayDetails({ ...birthDayDetails, additionalInfo: value })}
          name={"fadditionalInfo"}
        />
        <span>{t("w_tym_oknie_wpisz_przedzial_wiekowy_swojej_grupy")}</span>
      </Grid> */}

      <Grid item xs={4} className={"button-next"} style={{ marginTop: 40 }}>
        <EAButton
          title={t("kontynuuj")}
          onClick={() => onNext()}
          disabled={
            !validateForm() ||
            (!Boolean(birthDayDetails.customerName) &&
              !Boolean(birthDayDetails.customerLastName) &&
              !Boolean(birthDayDetails.email) &&
              !Boolean(birthDayDetails.phone))
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default ThirdStep;
